import styled from "styled-components";

export const H3Component = styled.h2`
    margin: 0;
    font-weight: 700;
    font-size: 14px;
    color: var(--text-color);
`